import ara from './ara.json';
import bgn from './bgn.json';
import csb from './csb.json';
import deu from './deu.json';
import en from './en.json';
import fra from './fra.json';
import grc from './grc.json';
import hin from './hin.json';
import ita from './ita.json';
import jpn from './jpn.json';
import kor from './kor.json';
import nld from './nld.json';
import np from './np.json';
import pl from './pl.json';
import por from './por.json';
import ro from './ro.json';
import rus from './rus.json';
import spa from './spa.json';
import tgl from './tgl.json';
import tur from './tur.json';
import vie from './vie.json';
import zho from './zho.json';

const preferredLang = [
  { ara },
  { bgn },
  { csb },
  { deu },
  { en },
  { fra },
  { grc },
  { hin },
  { ita },
  { jpn },
  { kor },
  { nld },
  { np },
  { pl },
  { por },
  { ro },
  { rus },
  { spa },
  { tgl },
  { tur },
  { vie },
  { zho }
];

export default preferredLang;
